<template>
    <div class="p-4" style="z-index: 199999; pointer-events: auto;">
        <a-card title="Buscar Imóveis por Proprietário" bordered>
            <a-form layout="inline" @submit.prevent>
                <a-form-item class="flex-1">
                    <a-input
                        style="z-index: 199999; pointer-events: auto;"
                        ref="searchInput"
                        v-model:value="searchTerm"
                        placeholder="Digite nome ou CPF/CNPJ"
                        @click="emits('changeInputValue')"
                        allow-clear
                    />
                </a-form-item>
            </a-form>

            <div v-if="loading" class="mt-4 text-center">
                <a-spin />
            </div>

            <div v-else-if="filteredResults.length > 0" class="mt-4">
                <a-collapse accordion>
                    <a-collapse-panel
                        v-for="owner in filteredResults"
                        :key="owner.cgm"
                    >
                        <template #header>
                            {{ owner.name }} ({{ formatCode(owner.code) }})
                        </template>
                        <a-list bordered>
                            <a-list-item
                                v-for="item in owner.propertyIds"
                                :key="item"
                            >
                                <a-tag style="cursor: pointer; display: flex; justify-content: space-between; width: 100%; padding: 8px 10px" color="blue" @click="selectProperty(item.property_id)">
                                    Imóvel de Inscrição Municipal: {{ item.property_id }}

                                    <div>
                                        <a-tag :color="(item.type === 'Proprietário') ? 'success' : 'warning'">{{ item.type }} - {{ item.order }}</a-tag>
                                    </div>
                                </a-tag>
                            </a-list-item>
                        </a-list>
                    </a-collapse-panel>
                </a-collapse>
            </div>

            <div v-else-if="searchTerm" class="mt-4 text-center text-gray-500">
                Nenhum proprietário encontrado.
            </div>
        </a-card>
    </div>
</template>

<script setup>
import {ref, watch} from 'vue'
import axios from 'axios'

const searchTerm = ref('')
const filteredResults = ref([])
const loading = ref(false)
let debounceTimer = null
const emits = defineEmits(['selectProperty', 'changeInputValue'])
const searchInput = ref(null)

const selectProperty = (propertyId) => {
    emits('selectProperty', propertyId)
}

watch(
    searchTerm,
    (term) => {
        clearTimeout(debounceTimer)

        const trimmed = term.trim()
        if (!trimmed) {
            filteredResults.value = []
            return
        }

        if (trimmed.length < 3) {
            filteredResults.value = []
            return
        }

        loading.value = true

        debounceTimer = setTimeout(async () => {
            try {
                const response = await window.axios.get('/api/e-cidade/owners', {
                    params: { data: trimmed },
                })

                filteredResults.value = response.data.data || []
            } catch (error) {
                console.error('Erro ao buscar proprietários:', error)
                filteredResults.value = []
            } finally {
                loading.value = false
            }
        }, 400)
    },
    { immediate: true }
)

const formatCode = (code) => {
    if (code.length === 11) {
        return code.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    } else if (code.length === 14) {
        return code.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    }
}
</script>

<style scoped>
.mt-4 {
    margin-top: 1rem;
}
.flex-1 {
    flex: 1;
}
</style>
